var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('p',{staticClass:"tip"},[_vm._v("当前所在位置："),_c('span',{staticClass:"path"},[_vm._v(_vm._s(_vm.location))])]),_c('p',[_vm._v("页面尚在开发中哦～")])])
}
var staticRenderFns = []

export { render, staticRenderFns }